import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LoginFormComponent } from './login-form.component'
import {
  CmsConfig,
  NotAuthGuard,
  UrlModule,
  I18nModule,
  ConfigModule,
} from '@spartacus/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { FormErrorsModule, PageSlotModule } from '@spartacus/storefront'
import { environment } from '../../../../environments/environment'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    PageSlotModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ReturningCustomerLoginComponent: {
          component: LoginFormComponent,
          guards: [NotAuthGuard],
        },
      },
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['loginForm'],
        },
      },
    } as CmsConfig),
  ],
  providers: [CommonModule],
  declarations: [LoginFormComponent],
  exports: [LoginFormComponent],
})
export class LoginFormModule {}
